import React from "react"
import { useTranslation } from "react-i18next"

import { Crumb, useBreadcrumbsContext } from "./BreadcrumbsProvider"
import styles from "./index.module.css"

type BreadcrumbsProps = {
  crumbs?: Crumb[]
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ crumbs = [] }) => {
  const { t } = useTranslation()
  const ssrCrumbs = useBreadcrumbsContext()
  const breadcrumbs = ssrCrumbs.length > 0 ? ssrCrumbs : crumbs
  const isCases = breadcrumbs[1] && breadcrumbs[1].name === "cases"
  const breadcrumbsCases = breadcrumbs.reduce((prev: Crumb[], curr) => {
    const currBreadCrumb = prev.find((breadCrumb) => breadCrumb.name === curr.name)

    if (!currBreadCrumb && curr.name !== "cases") {
      prev.push(curr)
    }

    if (!currBreadCrumb && curr.name === "cases") {
      prev.push({ ...curr, name: `${breadcrumbs[0].name}.cases` })
    }

    return prev
  }, [])

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Arrow}>
        <svg fill="none" height="13" width="7" xmlns="http://www.w3.org/2000/svg">
          <path
            clipRule="evenodd"
            d="M5.63.664l.74.672L1.676 6.5l4.694 5.165-.74.672L.324 6.5 5.63.664z"
            fill="none"
            fillRule="evenodd"
          />
        </svg>
      </div>

      {[{ name: "home", href: "/" }, ...(isCases ? breadcrumbsCases : breadcrumbs)].map(
        ({ name, href }) => (
          <a
            dangerouslySetInnerHTML={{ __html: t(`page.${name}`, name) }}
            key={name}
            className={styles.Item}
            href={name !== "ideas" ? href : undefined}
          />
        ),
      )}
    </div>
  )
}
